// Regex for detecting emails and phone numbers
const EMAIL_REGEX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
const PHONE_REGEX = /(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}/g;

export interface ContactInfo {
  type: 'email' | 'phone';
  value: string;
  messageId: string;
}

// Set to keep track of leads already detected in a conversation
const detectedLeads = new Set<string>();

export function resetDetectedLeads() {
  detectedLeads.clear();
}

export function detectContactInfo(message: string, messageId: string): ContactInfo[] {
  const contactInfo: ContactInfo[] = [];

  // Detect emails
  const emails = message.match(EMAIL_REGEX);
  if (emails) {
    emails.forEach(email => {
      const normalizedEmail = email.toLowerCase().trim();
      // Check if this email hasn't already been detected
      if (!detectedLeads.has(normalizedEmail)) {
        detectedLeads.add(normalizedEmail);
        contactInfo.push({
          type: 'email',
          value: email,
          messageId
        });
      }
    });
  }

  // Detect phone numbers
  const phones = message.match(PHONE_REGEX);
  if (phones) {
    phones.forEach(phone => {
      // Normalize the phone number by removing spaces, dots and dashes
      const normalizedPhone = phone.replace(/[\s.-]/g, '');
      // Check if this number hasn't already been detected
      if (!detectedLeads.has(normalizedPhone)) {
        detectedLeads.add(normalizedPhone);
        contactInfo.push({
          type: 'phone',
          value: phone,
          messageId
        });
      }
    });
  }

  return contactInfo;
}